import type { GroupsSwitchOrGotoCTAProps } from './components/GroupsSwitchOrGotoCTA';
import type { GroupContextMenuProps } from './components/GroupContextMenu';
import type { GroupRightCharmProps } from './components/GroupRightCharm';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupListTree" */ './lazyIndex'),
    { name: 'GroupListTree' }
);

// Delay loaded components
export const GroupRightCharm: LazyComponent<GroupRightCharmProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.GroupRightCharm);
export const GroupRightCharmHover: LazyComponent<GroupRightCharmProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.GroupRightCharmHover);
export const GroupContextMenu: LazyComponent<GroupContextMenuProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.GroupContextMenu);
export const GroupsSwitchOrGotoCTA: LazyComponent<GroupsSwitchOrGotoCTAProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.GroupsSwitchOrGotoCTA);
